export default "__VITE_ASSET__DHOYQIWf__"